"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A utility for isolating the work on window property.
 */
function createWindowUtil(windowProperty) {
    return {
        isEmpty: function () {
            return typeof window !== 'undefined' && !window[windowProperty];
        },
        getValue: function () {
            return typeof window !== 'undefined' && window[windowProperty];
        },
        isDifferent: function (dataLayer) {
            return typeof window !== 'undefined' && window[windowProperty] !== dataLayer;
        },
        setValue: function (dataLayer) {
            if (typeof window !== 'undefined') {
                ;
                window[windowProperty] = dataLayer;
            }
        },
    };
}
exports.createWindowUtil = createWindowUtil;
